import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './theme.scss'
import echarts from 'echarts'
Vue.use(ElementUI)

import {Message} from 'element-ui'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.$message = Message


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
